import { pb } from './pb';

// Services publics pour la page /services
export async function fetchServicesPublic(){
  const res = await pb.collection('services').getList(1, 50, {
    filter: 'published = true',
    sort: 'order,title',
  });
  return res.items;
}

// Helpers admin potentiels (pour plus tard)
export async function fetchServicesAdmin(page = 1, perPage = 50, search = ''){
  const filter = search ? `title ~ "%${search}%"` : '';
  return pb.collection('services').getList(page, perPage, {
    filter,
    sort: 'order,title',
  });
}

export async function createService(data){
  return pb.collection('services').create(data);
}

export async function updateService(id, data){
  return pb.collection('services').update(id, data);
}

export async function deleteService(id){
  return pb.collection('services').delete(id);
}
